import { AfterViewInit, Component, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { timer } from 'rxjs';

import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { Region } from 'src/app/model/region.model';
import { Role } from 'src/app/model/roles';

import { AccountSearchRequestDataView } from '../model/search-account-request-data-view';
import { AccountService } from '../service/account.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { ViewAccountComponent } from './view-account/view-account.component';

import { EditAccountComponent } from './edit-account/edit-account.component';
import { User } from 'src/app/component/auth/model/user.model';
import { UserModel, USERROLE } from '../model/user';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { MatMenuTrigger } from '@angular/material/menu';
import { PopOverComponent } from 'src/app/component/common-components/pop-over/pop-over.component';

const sortingDataAccessor = (item: User, property: string) => {
    switch (property) {
        case 'FIRSTNAME':
            if (item.PERSON?.FIRST_NAME) return item.PERSON?.FIRST_NAME?.toString().toLocaleLowerCase();
            else return '';
        case 'LASTNAME':
            if (item.PERSON?.LAST_NAME) return item.PERSON?.LAST_NAME?.toString().toLocaleLowerCase();
            else return '';
        case 'USERNAME':
            if (item.USER_ID) return item.USER_ID;
            else return '';
        case 'EMAIL':
            if (item?.EMAIL_ADDRESS) return item?.EMAIL_ADDRESS;
            else return '';
        case 'REGION':
            if (item.REGION?.NAME) return item.REGION?.NAME?.toString().toLocaleLowerCase();
            else return '';
        case 'ORGANIZATION':
            if (item.REGION?.ORGANIZATIONS_ID) return item.REGION?.ORGANIZATIONS_ID?.toString().toLocaleLowerCase();
            return '';
        case 'PHONENUMBER':
            if (item.TELEPHONE_NUMBERS == null || item.TELEPHONE_NUMBERS === undefined || item.TELEPHONE_NUMBERS.length <= 0) return '';
            else return item.TELEPHONE_NUMBERS[0].PHONE_NUMBER.toString().toLocaleLowerCase();
        case 'ROLES':
            if (item?.USER_ROLES && item.USER_ROLES[0].ROLE?.NAME) {
                return item?.USER_ROLES[0]?.ROLE?.NAME?.toString().toLocaleLowerCase();
            } else {
                return '';
            }
        case 'SCHOOLDISTRICT':
            if (item?.WORKS_FOR?.NAME) {
                return item?.WORKS_FOR?.NAME?.toString().toLocaleLowerCase();
            } else {
                return '';
            }
        case 'ACCOUNTSTATUS':
            if (item?.LOGIN_DETAIL_STATUS && item?.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES?.NAME)
                return item?.LOGIN_DETAIL_STATUS && item?.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES?.NAME.toString().toLocaleLowerCase();
            else return '';
        default:
            if (item?.ID) return item.ID;
            else return '';
    }
};

@Component({
    selector: 'app-search-accounts',
    templateUrl: './search-accounts.component.html',
    styleUrls: ['./search-accounts.component.scss']
})
export class SearchAccountsComponent implements OnInit, AfterViewInit {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) searchPaginator: MatPaginator;

    lstSelectedRegion: Region[] = [];
    lstSelecteddistrict: SchoolDistrict[] = [];
    lstSelectedRole: Role[] = [];
    isLoadingResults: boolean = false;
    disableButton: boolean = true;
    resetField: boolean = false;
    searchTextCtrl = new UntypedFormControl('');
    dataSource = new MatTableDataSource<User>();

    displayedColumns: string[] = [
        'ACTION',
        'FIRSTNAME',
        'LASTNAME',
        'USERNAME',
        'EMAIL',
        'REGION',
        'ORGANIZATION',
        'PHONENUMBER',
        'ROLES',
        'SCHOOLDISTRICT',
        'ACCOUNTSTATUS'
    ];
    msg = new MsgModel();
    constructor(public accountService: AccountService, private dialog: MatDialog) {}

    ngOnInit(): void {
        this.searchTextCtrl.valueChanges.subscribe((x) => {
            this.disableButton = !this.validateSearchEnable();
            if (!this.disableButton) this.msg = new MsgModel();
        });
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.searchPaginator;
    }
    regionEventEmitter(lstRegion: Region[]) {
        this.lstSelectedRegion = lstRegion;
        this.disableButton = !this.validateSearchEnable();
    }
    districtsEventEmitter(districts: SchoolDistrict[]) {
        this.lstSelecteddistrict = districts;
        this.disableButton = !this.validateSearchEnable();
    }

    roleEventEmitter(roles: Role[]) {
        this.lstSelectedRole = roles;
        this.disableButton = !this.validateSearchEnable();
    }
    applyFilter(event: any) {
        if (!this.disableButton) this.search();
    }
    search() {
        this.msg = new MsgModel();
        this.isLoadingResults = true;
        this.dataSource = new MatTableDataSource<User>();
        this.disableButton = true;
        if (this.validateSearchEnable() && this.isLoadingResults) {
            const accountRequest = {} as AccountSearchRequestDataView;
            accountRequest.searchString = this.searchTextCtrl?.value;
            accountRequest.regions = this.lstSelectedRegion;
            accountRequest.schoolDistricts = this.lstSelecteddistrict;
            accountRequest.roles = this.lstSelectedRole;

            this.accountService.getAccountSearchV2(accountRequest).subscribe((x: any) => {
                if (x['users'] === undefined) {
                    if (x['msg'] !== undefined) {
                        this.msg = x['msg'];
                    }
                } else {
                    let lstUser: User[] = JSON.parse(x['users']);
                    lstUser.sort((a, b) =>
                        (a.PERSON?.FIRST_NAME ? a.PERSON?.FIRST_NAME.toString() : '') > (b.PERSON?.FIRST_NAME ? b.PERSON?.FIRST_NAME : '') ? 1 : -1
                    );

                    this.dataSource.data = lstUser;
                    this.announceSortChange({ active: 'FIRSTNAME', direction: 'desc' });
                }
                this.isLoadingResults = false;
            });
        }
    }

    paginatorEvent() {
        this.dataSource.sortingDataAccessor = sortingDataAccessor;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.searchPaginator;
    }
    validateSearchEnable() {
        if (
            this.lstSelectedRegion.length > 0 ||
            this.lstSelecteddistrict.length > 0 ||
            this.lstSelectedRole.length > 0 ||
            this.searchTextCtrl.value?.length > 0
        ) {
            return true;
        } else return false;
    }

    reset() {
        this.searchTextCtrl.setValue('');
        this.resetField = !this.resetField;
        //This is optional code To resetthe value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        //Once ray emits reset for District need to implment.
        this.dataSource = new MatTableDataSource<User>();
        this.isLoadingResults = false;
        this.disableButton = true;
    }

    view(row: User) {
        this.accountService.getAccount({ id: row.ID }).subscribe((x) => {
            let u: UserModel = x;
            //u.REGION = row.REGION;
            //u.WORKS_FOR = row.WORKS_FOR;
            //u.TELEPHONE_NUMBERS = row.TELEPHONE_NUMBERS;

            const dialogRef = this.dialog.open(ViewAccountComponent, {
                disableClose: true,
                width: '90%',
                height: '90%',
                data: u
            });
            dialogRef.afterClosed().subscribe((result) => {});
        });
    }
    edit(row: any) {
        this.accountService.getAccount({ id: row.ID }).subscribe((x) => {
            let u: UserModel = x;
            const dialogRef = this.dialog.open(EditAccountComponent, {
                disableClose: true,
                width: '90%',
                height: '90%',
                data: u
            });
            dialogRef.afterClosed().subscribe((result: UserModel) => {
                if (result != undefined) {
                    let index = this.dataSource.data.findIndex((x) => x.ID === result.ID);
                    if (index >= 0) {
                        this.dataSource.data[index].LOGIN_DETAIL_STATUS = result.LOGIN_DETAIL_STATUS;
                        this.dataSource.data[index].PERSON!.FIRST_NAME = result.PERSON?.FIRST_NAME;
                        this.dataSource.data[index].PERSON!.LAST_NAME = result.PERSON?.LAST_NAME;
                        this.dataSource.data[index].EMAIL_ADDRESS = result.EMAIL_ADDRESS;
                        this.dataSource.data[index].WORK_TITLE = result.WORK_TITLE;
                        this.dataSource.data[index].WORKS_FOR = result?.WORKS_FOR;
                        this.dataSource.data[index].SCHOOL_DISTRICTS = result.SCHOOL_DISTRICTS;
                        this.dataSource.data[index].REGION = result?.REGION;
                        this.dataSource.data[index].USER_ROLES = result?.USER_ROLES;
                    }
                }
            });
        });
    }

    announceSortChange(sortState: Sort) {
        this.paginatorEvent();
    }

    getElementData(u: User) {
        if (u.TELEPHONE_NUMBERS == null || u.TELEPHONE_NUMBERS === undefined || u.TELEPHONE_NUMBERS.length <= 0) {
            return '';
        } else {
            return (
                u?.TELEPHONE_NUMBERS[0]?.CONTACT_MECHANISMS.PARTY_CONTACT_MECHANISMS[0]?.PARTY_CONTACT_MECHANISM_PURPOSES[0]?.CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE.substring(
                    0,
                    1
                ) +
                ': ' +
                u?.TELEPHONE_NUMBERS[0]?.PHONE_NUMBER
            );
        }
    }

    openDialogSchoolDistrict(sd: SchoolDistrict[]) {
        const dialogRef = this.dialog.open(PopOverComponent, {
            width: '350px',
            height: sd?.length < 5 ? '100px' : sd?.length > 5 ? '500px' : '250px',
            data: { key: sd.map((x) => x.DISTRICTS), start: 4 }
        });

        dialogRef.afterClosed().subscribe((result) => {});
    }
    openDialogRoles(ur: USERROLE[]) {
        const dialogRef = this.dialog.open(PopOverComponent, {
            width: '350px',
            height: ur?.length < 5 ? '100px' : ur?.length > 10 ? '500px' : '200px',
            data: { key: ur.map((x) => x.ROLE?.NAME), start: 4 }
        });

        dialogRef.afterClosed().subscribe((result) => {});
    }
}
